import { Component, Input, OnInit, OnDestroy, TemplateRef } from '@angular/core';
import { MemberQuery, TermsAndConditionsModel, TermsAndConditionsService, TermsAndConditionsType } from '@fgb/core';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fgbcl-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent implements OnInit, OnDestroy {
  @Input() type: TermsAndConditionsType = TermsAndConditionsType.General;
  @Input() defaultTerms: TemplateRef<any>;

  termsAndConditions: TermsAndConditionsModel;
  private _isDestroyed$ = new Subject<void>();

  constructor(private termsAndConditionsService: TermsAndConditionsService, private memberQuery: MemberQuery) {}

  ngOnInit() {
    this.memberQuery.userContext$
      .pipe(
        takeUntil(this._isDestroyed$),
        switchMap((member) => {
          return this.termsAndConditionsService.getTermsAndConditions(this.type, member?.lcid, member?.clubId);
        })
      )
      .subscribe((terms) => {
        this.termsAndConditions = terms[0];
      });
  }

  public ngOnDestroy(): void {
    this._isDestroyed$.next();
    this._isDestroyed$.complete();
  }
}
